class DebtMessage {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    this.closer = this.element.querySelector('[data-closer]');

    this.bind();
  }

  bind() {
    const instance = this;
    if (this.closer) {
      this.closer.addEventListener('click', () => {
        this.element.classList.add('_hidden');
        instance.request();
      });
    }
  }

  request() {
    const csrfParam = document.querySelector('meta[name="csrf-param"]').getAttribute('content');
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const data = {[csrfParam]: csrfToken};

    const jax = new Jax('/partner/api/close-debt-message', 'POST', true);
    jax.send(data).then(response => {
      console.log(response);
    });
  }
}

document.addEventListener('DOMContentLoaded', ()=> {
  const element = document.querySelector('[data-debt-message]');
  if (element) {
    new DebtMessage(element)
  }
});